import { RootState } from "../../../store";
export const getProfileInfo = (state: RootState) => state.getProfile;
